import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import authAxios from '../auth/authAxios';

const Header = () => {
  const { accounts } = useMsal();
  const user = accounts[0];

  useEffect(() => {
    // Creates user in database if they do not exist
    authAxios.get('/api/users/me').then(res => {
      const {
        user_id,
        display_name,
        score,
      } = res.data;
    });
  }, []);

  // Tell TypeScript to expect an object with given_name (if it exists)
  const claims = user?.idTokenClaims as { given_name?: string } | undefined;

  const firstName: string =
    claims?.given_name ||
    user?.name?.split(', ')[1] ||
    'User';

  return (
    <header className="w-full h-16 px-6 shadow flex items-center justify-between print:hidden">
      <h1 className="text-xl font-bold lg:block hidden">&nbsp;</h1>
      {/* Add space for mobile hamburger button */}
      <div className="lg:hidden w-12"></div>
      <div className="flex items-center gap-4">
        <span className="text-sm">Welcome, {firstName}</span>
        <div className="w-8 h-8 rounded-full bg-primary text-lg text-white flex items-center justify-center">
          {firstName.charAt(0)}
        </div>
      </div>
    </header>
  );
};

export default Header;
